import React from 'react';
import PropTypes from 'prop-types';

import { CompanyBadge, ButtonsGroup } from '../../components';
import { Badge, Loader, Icon } from '../../ui-kit';
import './styles.scss';

const CompaniesView = (props) => (
  <>
    <ButtonsGroup
      loading={
        props.companies.moderatedCompanies.loading
        || props.companies.allCompanies.loading
        || props.companies.declinedCompanies.loading
        || props.updateDataLoading
      }
      activeTabIndex={props.activeTab}
      badges={[
        {
          name: 'Сompanies awaiting moderation',
          separator: true,
        },
        {
          name: 'All companies',
        },
        {
          name: 'Declined companies',
        },
      ]}
      setActiveTab={(index) => props.setActiveTab(index)}
      refreshAction={() => props.refreshAction()}
    />
    <div className="companies_sort_container">
      <Badge
        value="Sort by registration date"
        onClick={() => {props.sortCompanies(props.directionRenderStr())}}
        rightArrow={(
          <div className="badge_short_arrow">
            <Icon name={`arrow-${props.directionStr === 'desc' || !props.directionStr
              ? 'up'
              : 'down'}-short`}
            />
          </div>
        )}
        disabled={
          props.companies.moderatedCompanies.loading
          || props.companies.allCompanies.loading
          || props.companies.declinedCompanies.loading
          || props.updateDataLoading
        }
      />
    </div>
    {props.companies.moderatedCompanies.loading || props.companies.allCompanies.loading ? (
      <div className="companies_page_loader__block">
        <Loader type="big-loader" />
      </div>
    ) : (
      <div className={`companies_items_page__container ${props.updateDataLoading ? 'companies_blur' : ''}`}>
        <div className="companies_items__container">
          {props.activeTab === 0
          && props.companies.moderatedCompanies.success
          && props.companies.moderatedCompanies.data.map((item) => (
            <CompanyBadge
              name={item.name}
              uid={item.representativeId}
              companyId={item.companyId}
              logo={item.logo}
              phone={item.phone}
              link={item.link}
              status={item.status}
              location={item.addresses}
              acceptCompany={() => props.acceptCompany(item.companyId, 'del')}
              banCompany={() => props.banCompany(item.companyId, 'del')}
            />
          ))}
          {props.activeTab === 1
          && props.companies.allCompanies.success
          && props.companies.allCompanies.data.map((item) => (
            <CompanyBadge
              name={item.name}
              companyId={item.companyId}
              uid={item.representativeId}
              logo={item.logo}
              phone={item.phone}
              link={item.link}
              status={item.status}
              showBadges
              location={item.addresses}
              banCompany={() => props.banCompany(item.companyId)}
              acceptCompany={() => props.acceptCompany(item.companyId)}
            />
          ))}
          {props.activeTab === 2
          && props.companies.declinedCompanies.success
          && props.companies.declinedCompanies.data.map((item) => (
            <CompanyBadge
              name={item.name}
              uid={item.representativeId}
              companyId={item.companyId}
              logo={item.logo}
              phone={item.phone}
              link={item.link}
              status={item.status}
              showBadges
              location={item.addresses}
              acceptCompany={() => props.acceptCompany(item.companyId, 'del')}
            />
          ))}
        </div>
        {props.activeTab === 0
            && props.companies.moderatedCompanies.success
            && props.companies.allCompanies.success
            && props.companies.moderatedCompanies.data.length === 0 && (
            <div className="companies_empty__container">
              <div className="companies_empty">
                <Icon name="calendar-checked" />
                <p>No companies awaiting moderation</p>
              </div>
            </div>
        )}
      </div>
    )}
  </>
);

CompaniesView.propTypes = {
  companies: PropTypes.object,
  updateDataLoading: PropTypes.bool,
  activeTab: PropTypes.number,
  setActiveTab: PropTypes.func,
  refreshAction: PropTypes.func,
  acceptCompany: PropTypes.func,
  banCompany: PropTypes.func,
  directionStr: PropTypes.string,
};
CompaniesView.defaultProps = {
  companies: {},
  acceptCompany: () => {},
  updateDataLoading: false,
  setActiveTab: () => {},
  activeTab: 1,
  refreshAction: () => {},
  banCompany: () => {},
  directionStr: 'desc',
};

export default CompaniesView;
